import { render, staticRenderFns } from "./wx-nav.vue?vue&type=template&id=3f8f3f6d"
import script from "./wx-nav.vue?vue&type=script&lang=js"
export * from "./wx-nav.vue?vue&type=script&lang=js"
import style0 from "./wx-nav.vue?vue&type=style&index=0&id=3f8f3f6d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports